import AssetSubmissionVideoDetail from "Components/Shared/AssetSubmissionVideos/AssetSubmissionVideoDetail";

const PromotionalVideoSubmissionDetail = () => {
  return <AssetSubmissionVideoDetail uploadPurpose="featured" />;
};

export default PromotionalVideoSubmissionDetail;
